import React from 'react';
import EstimatingOverview from '../../estimating/EstimatingOverview';

export default function GnContractor() {
  return <EstimatingOverview contractor />;
}
